
const UtilsService = {
    getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace("\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }
}
export default UtilsService;